import { render, staticRenderFns } from "./GeneralPanel.vue?vue&type=template&id=c32a5f8c&"
import script from "./GeneralPanel.vue?vue&type=script&lang=js&"
export * from "./GeneralPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports